import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import classes from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../Actions/AxiosInstance";
import { DateConversion } from "../../../../Utils/dates";
import { ValidateAction, ValidateReqField } from "../../../../Utils/Validation";
import addressEmployee from "../../../../Assets/Images/banking.jpg";
import createstore from "../../../../store";
import CreateComp from "../create";
import importantsvg from "../../../../Assets/Svg/important-dates.svg";
import {
  getEJ2CalenderDateFormat,
  getFormattedDate,
  convertDateForBackend,
} from "../../../../Utils/index";
import If from "../../../../Component/Common/If";
import { DatePickerComponent } from "../../../../Component/Custom";

class EmpImportantDates extends React.Component {
  constructor(props) {
    super(props);
    this.SelectDate = this.SelectDate.bind(this);
    this.state = {
      maxDate: new Date(),
      startDate: new Date(),
      nodata: false,
      fields: {
        dob: "",
        partnerdob: "",
        marriageanniversarydate: "",
      },
      reqFields: {
        dob: "",
      },
      errors: {},
      helperText: {},
      hideButton: false,
      data: {},
      dataReceived: false,
      viewpage: true,
    };
  }

  componentDidMount() {
    if (this.state.data.dob) {
      this.setState({ hideButton: false }, () => {
        if (this.firstElement) this.firstElement.input.onFocus();
      });
    }

    if (this.firstElement) this.firstElement.focus();
    // CustomForm();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];

    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        ShortDateFormat,
      },
      () => {
        this.GetImportantDates();
      },
    );
  }

  ConvertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  SelectDate(a, args) {
    const { fields } = this.state;
    if (args.value) {
      const date = args.value;
      fields[a] = date;
    } else {
      fields[a] = null;
    }
    this.setState({ fields });
  }

  GetImportantDates() {
    const URL = "employee/getempallpersonaldates";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let data = {};
        result.data.result.length > 0
          ? (data = result.data.result[0])
          : (data = {});
        const fields = {
          dob: data.dob,
          marriageanniversarydate: data.marriageanniversarydate,
          partnerdob: data.partnerdob,
        };
        const reqFields = {
          dob: data.dob,
        };
        const objArray = Object.values(data);
        if (objArray[0] == null) {
          this.setState({ nodata: true, viewpage: false });
        }
        this.setState({
          fields,
          reqFields,
          data,
          dataReceived: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdateImportantDates() {
    const data = {
      dob: convertDateForBackend(this.state.fields.dob),
      marriageanniversarydate: convertDateForBackend(
        this.state.fields.marriageanniversarydate,
      ),
      partnerdob: convertDateForBackend(this.state.fields.partnerdob),
      employeeid: this.props.colleagueid || this.state.employeeid,
    };

    if (!createstore.getState().AuthenticationAction.IsFulfilled) {
      Object.assign(data, {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      });
    }

    instance
      .post("employee/updateemppersonaldates", data)
      .then((result) => {
        this.props.enqueueSnackbar("Saved successfully", {
          variant: "success",
        });
        this.setState({ viewpage: true });
        this.GetImportantDates();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  isEmpty(obj) {
    return !obj.dob && !obj.marriageanniversarydate && !obj.partnerdob;
  }

  getDate = (str) => {
    const res = new Date(str);
    return res;
  };

  getEditMode() {
    this.setState(
      {
        viewpage: false,
        nodata: false,
      },
      () => {
        if (this.firstElement) this.firstElement.input.onFocus();
      },
    );
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  showComp = (value) => <div className="address-data">{value || "-"}</div>;

  render() {
    const {
      data,
      ShortDateFormat,
      dataReceived,
      viewpage,
      hideButton,
      nodata,
    } = this.state;
    return (
      <div>
        <svg
          className={`margin-top-20 margin-right-20 ${
            !viewpage || hideButton
              ? "hide-button"
              : "address-edit cursour-pointer"
          }`}
          onClick={this.getEditMode.bind(this)}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style={{ zIndex: 10 }}
        >
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
        </svg>
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {nodata && !viewpage ? (
                <CreateComp
                  text="Add your important dates"
                  heading={
                    <FormattedMessage
                      id="LbImportantDates"
                      defaultMessage="Important Dates"
                    />
                  }
                  onCreate={this.getEditMode.bind(this)}
                  imageSrc={importantsvg}
                />
              ) : (
                <div className="form-height">
                  <div id="div">
                    <form
                      className="custom-form-box profile-imp-dates"
                      autoComplete="off"
                    >
                      <div className="inner-wrapper opaque" tabIndex="0">
                        <div className="margin-bottom-20 margin-bottom-20 dependent-datepicker">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbYourBirthDate"
                              defaultMessage="Birth Date"
                            />
                          </p>
                          {viewpage ? (
                            this.showComp(
                              getFormattedDate(data.dob),
                              // DateConversion(data.dob, ShortDateFormat)
                            )
                          ) : (
                            <div>
                              <DatePickerComponent
                                placeholder="Date Of Birth"
                                format={getEJ2CalenderDateFormat()}
                                width={"100%"}
                                id="dob"
                                start="Decade"
                                allowEdit={true}
                                max={this.state.maxDate}
                                // onClick={() => this.dateObj3.show()}
                                // // ref={(date)) => (this.dateObj3 = date)}
                                change={(e) => this.SelectDate("dob", e)}
                                value={get(this.state, "fields.dob", "")}
                                // onBlur={this.ValidateField.bind(this, "dob", "")}
                              />
                              <div>
                                {this.state.errors.dob ? (
                                  <span className="caption-error">
                                    <FormattedMessage
                                      id="Erdob"
                                      defaultMessage="can not be empty"
                                    />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="inner-wrapper opaque" tabIndex="1">
                        <div className="margin-bottom-20 margin-bottom-20 dependent-datepicker">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbYourPartnerBirthDate"
                              defaultMessage="Your partner birth date"
                            />
                          </p>
                          {viewpage ? (
                            this.showComp(getFormattedDate(data.partnerdob))
                          ) : (
                            <div>
                              <DatePickerComponent
                                placeholder="Date Of Birth"
                                width={"100%"}
                                style={{ height: "auto !important" }}
                                format={getEJ2CalenderDateFormat()}
                                // onClick={() => this.dateObj1.show()}
                                // ref={(date)) => (this.dateObj1 = date)}
                                id="dob"
                                start="Decade"
                                max={this.state.maxDate}
                                change={(e) => this.SelectDate("partnerdob", e)}
                                value={get(this.state, "fields.partnerdob", "")}
                                allowEdit={true}
                                // onBlur={this.ValidateField.bind(this, "partnerdob", "")}
                              />
                              <div>
                                {this.state.errors.partnerdob ? (
                                  <span className="caption-error">
                                    {" "}
                                    <FormattedMessage
                                      id="Erpartnerdob"
                                      defaultMessage="can not be empty"
                                    />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="inner-wrapper" tabIndex="2">
                        <div className="margin-bottom-20 dependent-datepicker">
                          <p className="input-form-label">
                            Marriage anniversary
                          </p>
                          {viewpage ? (
                            this.showComp(
                              getFormattedDate(data.marriageanniversarydate),
                              // DateConversion(data.marriageanniversarydate, ShortDateFormat)
                            )
                          ) : (
                            <div>
                              <DatePickerComponent
                                placeholder="Marriage Aniversiry"
                                format={getEJ2CalenderDateFormat()}
                                width={"100%"}
                                id="dob"
                                start="Decade"
                                allowEdit={true}
                                height={"auto !important"}
                                // onClick={() => this.dateObj2.show()}
                                // ref={(date)) => (this.dateObj2 = date)}
                                max={this.state.maxDate}
                                change={(e) =>
                                  this.SelectDate("marriageanniversarydate", e)
                                }
                                value={get(
                                  this.state,
                                  "fields.marriageanniversarydate",
                                  "",
                                )}
                                // onBlur={this.ValidateField.bind(this, "marriageanniversarydate", "")}
                              />
                              <div>
                                {this.state.errors.marriageanniversarydate ? (
                                  <span className="caption-error">
                                    {" "}
                                    <FormattedMessage
                                      id="ErMarriageAnniversary"
                                      defaultMessage="can not be empty"
                                    />
                                  </span>
                                ) : (
                                  ""
                                )}{" "}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {!viewpage && (
                        <div className="upform-footer">
                          <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className="form-btn"
                            onClick={this.UpdateImportantDates.bind(this)}
                          >
                            <FormattedMessage
                              id="BtSave"
                              defaultMessage="Save"
                            />
                          </Button>
                          <span className="margin-left-16">
                            <Button
                              size="large"
                              className={classes.button}
                              onClick={() =>
                                this.setState({
                                  viewpage:
                                    this.state.data.dob == null ? false : true,
                                  nodata:
                                    this.state.data.dob == null ? true : false,
                                })
                              }
                            >
                              <FormattedMessage
                                id="BtCancel"
                                defaultMessage="CANCEL"
                              />
                            </Button>
                          </span>
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default withSnackbar(EmpImportantDates);
